<template>
  <el-container type="flex" class="main_container">
    <base-header>
      <el-radio-group v-model="type" size="mini" @change="changeList" :disabled="loading">
        <el-radio-button :label="0">退款申请</el-radio-button>
        <el-radio-button :label="1">已同意</el-radio-button>
        <el-radio-button :label="2">已拒绝</el-radio-button>
      </el-radio-group>
    </base-header>
    <el-main>
      <el-table :data="refundOrderList" height="100%" v-loading="loading">
        <el-table-column label="商品图片" width="140" align="center">
          <template v-slot="scope">
            <img :src=scope.row.good_pic alt="" style="width: 100px; height: 100px">
          </template>
        </el-table-column>
        <el-table-column
          v-for="item in tableColumn1"
          :key="item.prop"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          align="center">
        </el-table-column>
        <el-table-column label="买家微信头像昵称" width="140">
          <template v-slot="scope">
            <div style="display: flex; align-items: center;">
              <img v-if="scope.row.user_avatar_url" :src=scope.row.user_avatar_url style="width: 30px; height: 30px;">
              {{scope.row.user_nickname}}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="代销团长" width="140">
          <template v-slot="scope">
            <div style="display: flex; align-items: center;">
              <img v-if="scope.row.seller_avatar_url" :src=scope.row.seller_avatar_url style="width: 30px; height: 30px;">
              {{scope.row.seller_nickname}}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          v-for="item in tableColumn2"
          :key="item.prop"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          align="center">
        </el-table-column>
        <el-table-column
          v-if="type === 2"
          prop="reason"
          label="失败原因"
          align="center">
        </el-table-column>
        <el-table-column label="操作退款" align="center" width="150">
          <template v-slot="scope">
            <div v-if="!type && !scope.row.status">
              <span @click="handleRefundOrder(1, scope.row)">同意</span>
              <span style="color: red; margin-left: 20px;" @click="handleRefundOrder(0, scope.row)">拒绝</span>
            </div>
            <div v-else>
              <div v-if="type === 2 || scope.row.status === 2" style="color: red;">已拒绝</div>
              <div v-if="type === 1 || scope.row.status === 1">已通过</div>
              <div v-if="scope.row.status === 3" style="color: red;">已失败</div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-footer class="footer">
      <el-pagination
        :total="totalCount"
        :page-size="pagesize"
        :current-page="page"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </el-footer>
  </el-container>
</template>

<script>
import pageMixin from '../../../../mixins/page'

export default {
  name: 'RefundOrder',
  mixins: [pageMixin],
  data () {
    return {
      refundOrderList: [],
      refundOrderListUrl: this.getDomain() + 'bmorder/get_refund_order_list',
      handleRefundOrderUrl: this.getDomain() + 'bmorder/handle_refund_order',
      loading: false,
      tableColumn1: [
        {
          prop: 'good_name',
          label: '商品名称'
        }, {
          prop: 'quantity',
          label: '数量'
        }, {
          prop: 'order_price',
          label: '金额（元）'
        }, {
          prop: 'order_status_show',
          label: '订单状态'
        }, {
          prop: 'pay_time',
          label: '下单时间'
        }
      ],
      tableColumn2: [
        {
          prop: 'consignee',
          label: '收货人'
        }, {
          prop: 'mobile',
          label: '联系电话'
        }, {
          prop: 'receive_address',
          label: '收货地址'
        }, {
          prop: 'user_reason',
          label: '退款原因'
        }
      ],
      type: 0
    }
  },
  methods: {
    getList () {
      this.loading = true
      let params = {
        page: this.page,
        pagesize: this.pagesize,
        status: this.type
      }
      let handle = res => {
        this.totalCount = res.data.content.total_count
        this.refundOrderList = res.data.content.data
        this.refundOrderList.forEach(item => {
          item.order_price = item.order_price / 100
          item.pay_time = this.timeTransform(item.pay_time)
          this.$set(item, 'status', 0)
          item.order_status_show = item.order_status === 0 ? '未发货' : item.order_status === 1 ? '已发货' : '已收货'
        })
      }
      let loadings = () => {
        this.loading = false
      }
      this.__axios(this.refundOrderListUrl, params, handle, loadings)
    },
    changeList () {
      this.page = 1
      this.pagesize = 50
      this.getList()
    },
    handleRefundOrder (type, row) {
      let params = {
        is_agree: type,
        t_refund_id: row.t_refund_id
      }
      let handle = () => {
        if (!type) {
          row.status = 2
        } else {
          row.status = 1
        }
      }
      let errorHandler = res => {
        if (res.data.err_code === 20001) {
          this.$message({
            type: 'error',
            message: res.data.content.desc
          })
          row.status = 3
        }
      }
      this.__confirm(
        `确认${type ? '同意' : '拒绝'}？`,
        this.__axios,
        [this.handleRefundOrderUrl, params, handle, () => {}, errorHandler])
    }
  },
  mounted () {
    this.getList()
  }
}
</script>

<style scoped>
  span {
    color: #3a8ee6;
    cursor: pointer;
  }
</style>
